import { render, staticRenderFns } from "./CodeEditorForm.vue?vue&type=template&id=b2917b4e&scoped=true"
import script from "./CodeEditorForm.vue?vue&type=script&lang=js"
export * from "./CodeEditorForm.vue?vue&type=script&lang=js"
import style0 from "./CodeEditorForm.vue?vue&type=style&index=0&id=b2917b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2917b4e",
  null
  
)

export default component.exports